import { c as _c } from "react/compiler-runtime";
import IcChevronRightLarge from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_chevron_down_large.svg';
import { cn } from '@ncai-axe/react-ui-v3/utils';
import styles from './styles.module.scss';
type DropdownTriggerButtonProps = React.ComponentPropsWithRef<'button'> & {
  size?: 'small' | 'medium' | 'large';
  state?: 'open' | 'closed';
  variant?: 'negative' | 'accent';
};
const DropdownTriggerButton = t0 => {
  const $ = _c(17);
  let children;
  let className;
  let props;
  let state;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      children,
      size: t1,
      className,
      state,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = state;
    $[5] = t1;
    $[6] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    state = $[4];
    t1 = $[5];
    variant = $[6];
  }
  const size = t1 === undefined ? "small" : t1;
  let t2;
  if ($[7] !== className) {
    t2 = cn(styles.dropdownTrigger, className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IcChevronRightLarge className={styles.arrow} />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== props || $[12] !== size || $[13] !== state || $[14] !== t2 || $[15] !== variant) {
    t4 = <button className={t2} data-size={size} data-state={state} data-variant={variant} {...props}>{children}{t3}</button>;
    $[10] = children;
    $[11] = props;
    $[12] = size;
    $[13] = state;
    $[14] = t2;
    $[15] = variant;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
DropdownTriggerButton.displayName = 'DropdownTriggerButton';
export default DropdownTriggerButton;